jQuery(document).ready(function(){
  // For each .brz-wrapper-clone element with a data-button-annotation attribute
  jQuery('.brz-wrapper-clone[data-button-annotation]').each(function(){
    // Get the text from the data attribute
    var annotationText = jQuery(this).attr('data-button-annotation');
    // Find the first .brz-btn inside this element
    var firstButton = jQuery(this).find('.brz-btn').first();
    // Create a new div with class "mad-button-annotation", set its text and initial opacity 0
    var annotationDiv = jQuery('<div class="mad-button-annotation" style="opacity: 0;">' + annotationText + '</div>');
    // Insert the annotation div immediately after the button
    firstButton.after(annotationDiv);
    // Change the opacity to 1 (animate the change over 500ms)
    annotationDiv.animate({opacity: 1}, 500);
  });
});
